"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequest$ = exports.UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequest$outboundSchema = exports.UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequest$inboundSchema = exports.UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurity$ = exports.UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurity$outboundSchema = exports.UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurity$inboundSchema = void 0;
exports.unmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurityToJSON = unmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurityToJSON;
exports.unmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurityFromJSON = unmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurityFromJSON;
exports.unmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequestToJSON = unmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequestToJSON;
exports.unmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequestFromJSON = unmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurity$;
(function (UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurity$) {
    /** @deprecated use `UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurity$inboundSchema` instead. */
    UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurity$.inboundSchema = exports.UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurity$inboundSchema;
    /** @deprecated use `UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurity$outboundSchema` instead. */
    UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurity$.outboundSchema = exports.UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurity$outboundSchema;
})(UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurity$ || (exports.UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurity$ = UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurity$ = {}));
function unmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurityToJSON(unmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurity) {
    return JSON.stringify(exports.UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurity$outboundSchema
        .parse(unmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurity));
}
function unmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteSecurity' from JSON`);
}
/** @internal */
exports.UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequest$inboundSchema = z.object({
    listing_id: z.string(),
    street_group_property_id: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "listing_id": "listingId",
        "street_group_property_id": "streetGroupPropertyId",
    });
});
/** @internal */
exports.UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequest$outboundSchema = z.object({
    listingId: z.string(),
    streetGroupPropertyId: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        listingId: "listing_id",
        streetGroupPropertyId: "street_group_property_id",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequest$;
(function (UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequest$) {
    /** @deprecated use `UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequest$inboundSchema` instead. */
    UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequest$.inboundSchema = exports.UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequest$inboundSchema;
    /** @deprecated use `UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequest$outboundSchema` instead. */
    UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequest$.outboundSchema = exports.UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequest$outboundSchema;
})(UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequest$ || (exports.UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequest$ = UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequest$ = {}));
function unmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequestToJSON(unmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequest) {
    return JSON.stringify(exports.UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequest$outboundSchema
        .parse(unmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequest));
}
function unmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'UnmatchPropertyListingPropertyListingsUnmatchPropertyListingDeleteRequest' from JSON`);
}
//# sourceMappingURL=unmatchpropertylistingpropertylistingsunmatchpropertylistingdelete.js.map